// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as SuspensionStatus from "../entity/SuspensionStatus.bs.js";
import * as SuspensionApiModel from "../api-model/SuspensionApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(SuspensionApiModel.res_decode(json), "SuspensionInfoEntityMapper.re").suspension_info;
  return {
          suspend_status: SuspensionStatus.fromString(model.suspend_status),
          suspension_history: List.map((function (suspension) {
                  return {
                          expiry_time: suspension.expiry_time,
                          comment: suspension.comment,
                          reason: suspension.reason,
                          status: SuspensionStatus.fromString(suspension.event),
                          administrator: suspension.administrator,
                          event_mode: suspension.event_mode,
                          event_time: suspension.event_time
                        };
                }), model.driver_suspension_history)
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
